import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'abc-community',
  templateUrl: './abc-community.component.html',
  styleUrls: ['./abc-community.component.css']
})
export class AbcCommunityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
